<div class="container p-0">
  <div class="row">
    <div class="col dialog-title">Please, enter document link</div>
  </div>
  <div class="row">
    <div class="col dialog-content">
      <div>
        <div class="row">
          <div class="col">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              [formControl]="link"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-end dialog-buttons">
    <div class="col-auto">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
